export default function ContactHero() {
  return (
    <>
      <div className="hero contact-hero">
        <section className="overlay">
          <div className="max-width">
            <h1 className="heading text-center">
              <span>Contact</span> Us
            </h1>
            <p className="text-white mt-5 text-center">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit,
              deleniti!
            </p>
          </div>
        </section>
      </div>
    </>
  )
}
